import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseGetByComanyRequest, IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { IAddDeviceToRevisionRequest, ICreateRevisionDocumentRequest, ICompleteRevisionRequest, ICreateRevisionRequest, IDeleteDeviceToRevisionRequest, IDeleteRevisionDocumentRequest, IGetRevisionResponse, IRevision, IUpdateRevisionRequest, IUpdateRevisionResponse, IRevisionReducedDto } from '../models/revision';
import { IDeviceDetailsResponse } from 'src/app/devices/models/device';


@Injectable({
  providedIn: 'root'
})
export class RevisionService {

  constructor(private http: HttpClient) { }




  // Revision
  createRevision(request: ICreateRevisionRequest) {
    return this.http.post<IGetRevisionResponse>(
      `${environment.baseUrl}/v1/revisions/createRevision`,
      request
    )
  }

  getRevisions(request: IBaseSearchRequest){
    return this.http.post<IPagedResults<IGetRevisionResponse[]>>(
      `${environment.baseUrl}/v1/revisions/searchRevisions`,
      request
    )
  }

  getRevisionsByCompany(request: IBaseGetByComanyRequest){
    return this.http.post<IPagedResults<IGetRevisionResponse[]>>(
      `${environment.baseUrl}/v1/revisions/searchRevisionsByCompany`,
      request
    )
  }

  getRevisionById(id: string){
    return this.http.get<IGetRevisionResponse>(
      `${environment.baseUrl}/v1/revisions/getRevision/${id}`
    )
  }

  createRevisionReport(request: ICreateRevisionDocumentRequest){
    return this.http.post<IRevisionReducedDto>(
      `${environment.baseUrl}/v1/revisions/createRevisionReport`,
      request
    )
  }

  deleteRevisionReport(id: string){
    return this.http.delete<IRevision>(
      `${environment.baseUrl}/v1/revisions/deleteRevisionReport/${id}`
    )
  }

  updateRevision(request: IUpdateRevisionRequest){
    return this.http.put<IGetRevisionResponse>(
      `${environment.baseUrl}/v1/revisions/updateRevision/${request.id}`,
      request
    )
  }

  completeRevision(request: ICompleteRevisionRequest){
    return this.http.put<IGetRevisionResponse>(
      `${environment.baseUrl}/v1/revisions/completeRevision/${request.id}`,
      request
    )
  }

  addDeviceToRevision(request: IAddDeviceToRevisionRequest){
    return this.http.put<IDeviceDetailsResponse>(
      `${environment.baseUrl}/v1/revisions/addDeviceToRevision/${request.revisionId}`,
      request
    )
  }

  deleteRevision(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/revisions/deleteRevision/${id}`
    )
  }

  deleteDeviceFromRevision(request: IDeleteDeviceToRevisionRequest){
    return this.http.put<IGetRevisionResponse>(
      `${environment.baseUrl}/v1/revisions/deleteDeviceFromRevision/${request.id}`,
      request
    )
  }
}
